/** @format */

import { Outlet } from "react-router-dom";
import { Header } from "../Header/Header";
import { MainNavigation } from "../MainNavigation/MainNavigation";
import { useTranslation } from "react-i18next";
import { Footer } from "@edres/core";
import i18n from "../../features/i18n/init";
import { FeedbackButton } from "../FeedbackButton";
import { WhatsChangedButton } from "../../features/whatsChanged/WhatsChangedButton";
import { CookieNotice } from "../../features/cookieNotice/CookieNotice";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";
import { FLAG_CHANGELOG } from "../../featureFlags/constants";

export const PublicLayout = () => {
	const { t } = useTranslation();
	const canShowChangelog = useFeatureFlag(FLAG_CHANGELOG);

	return (
		<div className="h-screen flex flex-col bg-(--public-color-page-bg) text-base">
			{/* Rendered first so the OK button is the first tab stop.*/}
			<CookieNotice />
			<Header appTitle={t("common.appTitle")} />

			<div className="flex flex-1 flex-col md:flex-row md:overflow-hidden w-full gap-5">
				<aside
					aria-label="Side bar"
					className="flex shrink-0 w-full md:w-24 md:h-full items-start px-3 md:px-2 pt-2 md:pt-5 text-(--public-color-text-default) bg-white md:border-r md:border-(--public-color-border-default)"
				>
					<MainNavigation />
				</aside>

				<main className="flex-1 md:overflow-y-auto md:pb-2 md:pt-5">
					<Outlet />
				</main>
			</div>
			<Footer
				i18n={i18n}
				className=" flex flex-col sm:flex-row justify-between items-left gap-2 bg-white shrink-0 font-roboto text-(--public-color-text-default) border-t border-[#bbb] px-4 sm:px-5 py-3 [&_ul]:flex [&_ul]:flex-row [&_ul]:items-center [&_ul]:gap-2 [&_nav_a]:underline [&_nav_a]:text-(--public-color-theme-primary)  "
			/>
			{canShowChangelog && <WhatsChangedButton />}
			<FeedbackButton />
		</div>
	);
};
